module.exports = __webpack_public_path__ + "static/102-a14f5bbdf53c59564bcbb63163e88d30.png";